import ChangeProfilePicture from "./ChangeProfilePic"
import DeleteAccount from "./DeleteAccount"
import EditProfile from "./EditProfile"
import UpdatePassword from "./UpdatePassword"

export default function Settings() {
  return (
    <>
      <div>
        <h1 className="mb-14 text-3xl font-medium text-richblack-5">
        Edit Profile
      </h1>
      
      <ChangeProfilePicture />
      <EditProfile />
      <UpdatePassword />
      <DeleteAccount />
      </div>
    </>
  )
}